<template>
  <el-form ref="ruleFormRef" class="userForm" :label-width="150">
    <div class="formTitle"><span></span>频繁出没规则</div>
    <el-row>
      <el-col :span="16">
        <el-form-item label="频次≥">
          <el-slider v-model="ruleForm.value"></el-slider>
          <!-- <el-input v-model="ruleForm.name" ></el-input> -->
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <!-- <el-form-item prop="" class="leftInput"> -->
        <el-input v-model="ruleForm.value"></el-input>
        <!-- </el-form-item> -->
      </el-col>
    </el-row>
    <div class="formTitle"><span></span>疑似离开规则</div>
    <el-row>
      <el-col :span="16">
        <el-form-item label="疑似未抓拍天数阈值≥">
          <el-input v-model="ruleForms.value"></el-input>天
          <!-- <el-slider v-model="ruleForm.name"></el-slider> -->
        </el-form-item>
      </el-col>
      <!-- <el-col :span="8">
        <el-form-item prop="" class="leftInput">
        <el-input v-model="ruleForm.name" ></el-input>
        </el-form-item>
      </el-col> -->
    </el-row>
  </el-form>
  <div class="footerBottom" prop="">
    <h-button @click="saveCllick" type="primary">保存</h-button>
    <h-button @click="close">取消</h-button>
  </div>
</template>
<script >
import { defineComponent, reactive, toRefs } from "vue";
import { getDict, dictUpdate } from "@/api/constant";
import _ from "lodash";
export default defineComponent({
  name: "",
  components: {},
  props: {
    stause: {
      type: Boolean,
    },
  },
  emits: ["closeDialog"],
  setup(props, context) {
    const data = reactive({
      ruleForm: {
        code: "",
        id: 0,
        name: "",
        orderNum: 0,
        remark: "",
        type: "often_out_role",
        value: 0,
      },
      ruleForms: {
        code: "",
        id: 0,
        name: "",
        orderNum: 0,
        remark: "",
        type: "maybe_level_role",
        value: 0,
      },
      oftenoutrole: [],
      maybelevelrole: [],
    });
    const refData = toRefs(data);
    // 获取数据字典
    const queryMenuType = async () => {
      const res = await getDict("often_out_rule");
      const age = await getDict("maybe_level_rule");
      data.oftenoutrole = res.dict[0];
      data.oftenoutrole.value = data.oftenoutrole.value * 1;
      data.maybelevelrole = age.dict[0];
      data.maybelevelrole.value = data.maybelevelrole.value * 1;
      data.ruleForm = _.cloneDeep(data.oftenoutrole);
      data.ruleForms = _.cloneDeep(data.maybelevelrole);
    };
    queryMenuType();
    const close = () => {
      context.emit("closeDialog");
    };
    const saveCllick = async () => {
      if (data.ruleForm.value) {
        const res = await dictUpdate(data.ruleForm);
        if (res.code === 0) {
          close();
          // data.ruleForm = res.dict[0];
        }
        context.emit("update:oftenoutrole", data.ruleForm.value);
      }
      if (data.ruleForms.value) {
        const res = await dictUpdate(data.ruleForms);
        if (res.code === 0) {
          close();
          // data.data.ruleForms = res.dict[0];
        }
        context.emit("update:maybelevelrole", data.ruleForms.value);
      }
    };

    return { ...refData, close, saveCllick };
  },
});
</script>
<style  lang='scss' scoped >
.userForm {
  height: 200px;
  :deep(.el-input) {
    width: 74px;
    text-align: left;
  }

  :deep(.el-form-item__label) {
    width: 100px;
  }
  :deep(.el-input__inner) {
    color: #333 !important;
    font-size: 16px;
  }
}
.formTitle {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  span {
    width: 3.5px;
    height: 16px;
    background-color: #5584ff;
    margin-right: 10px;
  }
}
.footerBottom {
  text-align: center;
  flex-direction: column;
}
.el-slider {
  width: 100%;
}
.leftInput {
  margin-left: 20px;
}
</style>